import React, { useEffect, useState } from "react";
import { Card, Row, Col, Empty, Tabs, Typography, Menu, Layout } from "antd";
import { Button } from "reactstrap";
import Meta from "antd/es/card/Meta";
import { useLocation, useNavigate } from "react-router-dom";
import Wrapper from "../views/common/commonWrapper";
import moment from "moment";
import Loader from "../views/common/loader";
import "../common.scss";
import kalashIcon from "../assets/icons/kalash.png";
import donationIcon from "../assets/icons/donation.png";
import dharmshalaIcon from "../assets/icons/dharmshala.png";
import applicationIcon from "../assets/icons/applications.png";
import { useDispatch, useSelector } from "react-redux";
import { logOut } from "../redux/slices/authSlice";
import ServiceList from "./serviceList";
import SevaBooking from "./sevaBooking";
import BookingHistory from "./bookingHistory";
import UserProfile from "./userProfile";
import AddDonation from "./addDonation";
import AddAccommodation from "./addAccommodation";
import BookingTable from "./bookingTable";
import DonationReceiptsTable from "./donationReciepts";
import ApplicationList from "./applications/applicationList";
import MyApplications from "./applications/myApplications";
import {
  HomeOutlined,
  CalendarOutlined,
  BookOutlined,
  ContainerOutlined,
  ProfileOutlined,
  UserOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  LogoutOutlined,
  BankOutlined
} from '@ant-design/icons';
import { FaBowlRice } from 'react-icons/fa6';
import logo from "../assets/logo/main-logo.png";
import { fetchImage } from "../utility/commonDownloadS3Image";

const { Sider, Content, Header } = Layout;

function SevaList() {
  const userDetails = useSelector((state) => state.auth);
  const trustData = userDetails && userDetails?.trustData;
  const [user, setUser] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("home");
  const [sevaList, setSevaList] = useState(false);
  const [bookingSeva, setBookingSeva] = useState(false);
  const [selectedSeva, setSelectedSeva] = useState(null);
  const [accommodationList, setAccommodationList] = useState(false);
  const [chaukaList, setChaukaList] = useState(false);
  const [chaturmasBookingList, setChaturmasBookingList] = useState(false);
  const [donationList, setDonationList] = useState(false);
  const [applicationList, setApplicationList] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (trustData) {
      const loadImages = async () => {
        const url = await fetchImage(
          trustData.trustLogo ? `${trustData.trustLogo["name"]}` : null
        );
        setImageUrl(url);
      };
      loadImages();
    }
  }, [trustData]);

  const isChaturmasMode = localStorage.getItem("logoutRedirectUrl")?.includes("bangalore-chaturmas");

  const homeData = [
    {
      _id: "1",
      title: "Seva/Pooja",
      buttonName: "View",
      isEnable: trustData?.isSevaEnabled,
      // description: "Description for Seva 1.",
      image: kalashIcon,
      key: "seva",
    },
    {
      _id: "2",
      title: isChaturmasMode ? "Aawas Booking" : "Accommodation Booking",
      buttonName: "Book",
      isEnable: trustData?.hasDharmshala,
      // description: "Description for Seva 2.",
      image: dharmshalaIcon,
      key: "accommodation",
    },
    {
      _id: "5",
      title: "Chauka Booking",
      buttonName: "Book",
      isEnable: false,
      image: dharmshalaIcon,
      key: "chauka",
    },
    {
      _id: "3",
      title: "Donation",
      buttonName: "Donation",
      isEnable: trustData?.donationViaPortfolioApp,
      // description: "Description for Seva 2.",
      image: donationIcon,
      key: "donation",
    },
    {
      _id: "4",
      title: "Applications",
      buttonName: "Apply",
      isEnable: trustData?.isApplicationEnabled,
      // description: "Description for Seva 2.",
      image: applicationIcon,
      key: "applications",
    },
    // Add more Seva data here
  ];

  const tabs = [
    {
      key: "home",
      label: "Home",
      icon: <HomeOutlined />,
      isEnable:
        trustData?.isSevaEnabled ||
        trustData?.hasDharmshala ||
        trustData?.donationViaPortfolioApp ||
        trustData?.isApplicationEnabled,
    },
    {
      key: "bookingHistory",
      label: "Booked Services",
      icon: <CalendarOutlined />,
      isEnable: trustData?.isSevaEnabled,
    },
    {
      key: "bookingTable",
      label: "Bookings",
      icon: <BookOutlined />,
      isEnable: trustData?.hasDharmshala,
    },
    {
      key: "donationReciepts",
      label: "Donation Reciepts",
      icon: <ContainerOutlined />,
      isEnable: trustData?.donationViaPortfolioApp,
    },
    {
      key: "myApplications",
      label: "My Applications",
      icon: <ProfileOutlined />,
      isEnable: trustData?.isApplicationEnabled,
    },
    { key: "account", label: "Account", icon: <UserOutlined />, isEnable: true },
  ];
  const enabledTabs = tabs.filter((tab) => tab.isEnable);

  // useEffect(() => {
  //   if (enabledTabs.length === 1 && enabledTabs[0].key === "account") {
  //     setActiveTab("account");
  //     navigate("/home?page=account", { replace: true });
  //   } else {
  //     setActiveTab("home");
  //     navigate("/home", { replace: true });
  //   }
  // }, [enabledTabs, navigate]);


  useEffect(() => {
    // Fetching user data from localStorage
    const userData = JSON.parse(localStorage.getItem("user"));
    setUser(userData);
  }, []);
  const tabPermissions = {
    home: true,
    bookingHistory: trustData?.isSevaEnabled ?? false,
    bookingTable: trustData?.hasDharmshala ?? false,
    donationReciepts: trustData?.donationViaPortfolioApp ?? false,
    myApplications: trustData?.isApplicationEnabled ?? false,
    account: true,
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const page = queryParams.get("page");

    // Default state
    setSevaList(false);
    setBookingSeva(false);
    setAccommodationList(false);
    setChaukaList(false);
    setChaturmasBookingList(false);
    setDonationList(false);
    setApplicationList(false);

    if (!page) {
      setActiveTab("home");
      return;
    }

    // Map query param → tab & content
    const pageMap = {
      sevaList: () => {
        setActiveTab("home");
        setSevaList(true);
      },
      bookSeva: () => {
        setActiveTab("home");
        setBookingSeva(true);
      },
      accommodation: () => {
        setActiveTab("home");
        setAccommodationList(true);
      },
      chauka: () => {
        navigate("/home", { replace: true });
        setActiveTab("home");
      },
      "chaturmas-booking": () => {
        setActiveTab("home");
        setChaturmasBookingList(true);
      },
      donation: () => {
        setActiveTab("home");
        setDonationList(true);
      },
      applications: () => {
        setActiveTab("home");
        setApplicationList(true);
      },
      bookingHistory: () => setActiveTab("bookingHistory"),
      bookings: () => setActiveTab("bookingTable"),
      bookings_aawas: () => setActiveTab("bookingTable"),
      bookings_chauka: () => {
        navigate("/home?page=bookings", { replace: true });
        setActiveTab("bookingTable");
      },
      account: () => setActiveTab("account"),
      donationReciepts: () => setActiveTab("donationReciepts"),
      myApplications: () => setActiveTab("myApplications"),
    };

    if (pageMap[page]) {
      // For sub-tabs, check permission of the parent tab
      const parentPage = page.startsWith('bookings_') ? 'bookings' : page;
      if (tabPermissions[parentPage] !== false) {
        pageMap[page]();
      } else {
        // Redirect to home if disabled
        navigate("/home", { replace: true });
        setActiveTab("home");
      }
    } else {
      // Invalid page → redirect home
      navigate("/home", { replace: true });
      setActiveTab("home");
    }
  }, [location.search, navigate, tabPermissions]);

  const handleButtonClick = (key, id) => {
    if (key === "seva") {
      setSevaList(true);
      setAccommodationList(false);
      setDonationList(false);
      setApplicationList(false);
      navigate(`/home?page=sevaList`);
    } else if (key === "accommodation") {
      setAccommodationList(true);
      setSevaList(false);
      setDonationList(false);
      setApplicationList(false);
      navigate(`/home?page=accommodation`);
    } else if (key === "donation") {
      setDonationList(true);
      setSevaList(false);
      setAccommodationList(false);
      setApplicationList(false);
      navigate(`/home?page=donation`);
    } else if (key === "applications") {
      setApplicationList(true);
      setDonationList(false);
      setSevaList(false);
      setAccommodationList(false);
      navigate(`/home?page=applications`);
    } else if (key === "chauka") {
      setChaukaList(true);
      setAccommodationList(false);
      setDonationList(false);
      setSevaList(false);
      setApplicationList(false);
      navigate(`/home?page=chauka`);
    }
  };

  // If no user data, show Seva list unless it's chaturmas-booking
  if (!user) {
    return (
      <Wrapper>
        <ServiceList
          hasUser={false}
          setSevaList={setSevaList}
          setBookingSeva={setBookingSeva}
        />
      </Wrapper>
    );
  }

  // Tabs content
  const isChaturmasSource = new URLSearchParams(location.search).get("source") === "chaturmas";

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      {isMobile ? (
        <div style={{ width: "100%", flexShrink: 0 }}>
          <Menu
            mode="horizontal"
            selectedKeys={[activeTab]}
            onClick={({ key }) => {
              const parentKey = key.split('_')[0];
              if (!tabPermissions[parentKey]) return;
              setActiveTab(key);
              switch (key) {
                case "bookingHistory":
                  navigate("/home?page=bookingHistory");
                  break;
                case "bookingTable":
                  navigate("/home?page=bookings");
                  break;
                case "bookingTable_aawas":
                  navigate("/home?page=bookings_aawas");
                  break;
                case "bookingTable_chauka":
                  navigate("/home?page=bookings_chauka");
                  break;
                case "account":
                  navigate("/home?page=account");
                  break;
                case "donationReciepts":
                  navigate("/home?page=donationReciepts");
                  break;
                case "myApplications":
                  navigate("/home?page=myApplications");
                  break;
                case "home":
                default:
                  navigate("/home");
                  setActiveTab("home");
                  setSevaList(false);
                  setAccommodationList(false);
                  setDonationList(false);
                  setApplicationList(false);
                  break;
              }
            }}
            items={enabledTabs.map((tab) => ({ key: tab.key, label: tab.label, icon: tab.icon, children: tab.children }))}
            style={{
              borderRadius: "0.428rem",
              border: "none",
              boxShadow: "0 4px 24px 0 rgba(34, 41, 47, 0.1)",
              padding: "0",
              backgroundColor: "#fff"
            }}
          />
        </div>
      ) : (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={(value) => setCollapsed(value)}
          trigger={null}
          theme="light"
          width={260}
          collapsedWidth={80}
          style={{
            boxShadow: "0 4px 24px 0 rgba(34, 41, 47, 0.1)",
            zIndex: 2,
          }}
        >
          <div style={{ height: "64px", display: "flex", alignItems: "center", justifyContent: "center", padding: collapsed ? "0" : "0 16px", overflow: "hidden", borderBottom: "1px solid #f0f0f0" }}>
            <img src={imageUrl || trustData?.trustLogo?.presignedUrl || logo} alt="Logo" style={{ height: "40px", width: collapsed ? "40px" : "auto", maxWidth: collapsed ? "40px" : "100%", objectFit: "contain" }} />
            {!collapsed && trustData?.name && !isChaturmasMode && <span style={{ marginLeft: "12px", fontWeight: "bold", fontSize: "16px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{trustData.name}</span>}
          </div>
          <Menu
            mode="inline"
            className="admin-sidebar-menu"
            selectedKeys={[activeTab]}
            onClick={({ key }) => {
              const parentKey = key.split('_')[0];
              if (!tabPermissions[parentKey]) return;
              setActiveTab(key);
              switch (key) {
                case "bookingHistory":
                  navigate("/home?page=bookingHistory");
                  break;
                case "bookingTable":
                  navigate("/home?page=bookings");
                  break;
                case "bookingTable_aawas":
                  navigate("/home?page=bookings_aawas");
                  break;
                case "bookingTable_chauka":
                  navigate("/home?page=bookings_chauka");
                  break;
                case "account":
                  navigate("/home?page=account");
                  break;
                case "donationReciepts":
                  navigate("/home?page=donationReciepts");
                  break;
                case "myApplications":
                  navigate("/home?page=myApplications");
                  break;
                case "home":
                default:
                  navigate("/home");
                  setActiveTab("home");
                  setSevaList(false);
                  setAccommodationList(false);
                  setDonationList(false);
                  setApplicationList(false);
                  break;
              }
            }}
            items={enabledTabs.map((tab) => ({ key: tab.key, label: tab.label, icon: tab.icon, children: tab.children }))}
            style={{
              border: "none",
              padding: "10px 0"
            }}
          />
        </Sider>
      )}
      <Layout style={{ background: "#f8f8f8" }}>
        <Header style={{ padding: '0 24px', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', zIndex: 1, position: 'relative' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button
              type="text"
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: '16px',
                width: 40,
                height: 40,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'transparent',
                border: 'none',
                padding: 0,
                color: '#533810',
                marginRight: '16px'
              }}
            >
              {collapsed ? <MenuUnfoldOutlined style={{ fontSize: '20px' }} /> : <MenuFoldOutlined style={{ fontSize: '20px' }} />}
            </Button>
          </div>
          {isChaturmasMode && trustData?.name && (
            <div
              className="position-absolute start-50 top-50 translate-middle text-center gold"
              style={{ fontSize: "clamp(1rem, 4vw, 1.8rem)", whiteSpace: "nowrap", zIndex: 0 }}
            >
              Welcome to {trustData.name}
            </div>
          )}
          <div style={{ display: 'flex', alignItems: 'center', zIndex: 1 }}>
            {user && (
              <Button color="primary" onClick={() => {
                const redirectUrl = localStorage.getItem("logoutRedirectUrl");
                dispatch(logOut());
                if (redirectUrl) window.location.href = redirectUrl;
                else window.location.href = "/";
              }} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <LogoutOutlined /> Logout
              </Button>
            )}
          </div>
        </Header>
        <Content style={{ padding: "24px", minWidth: 0, overflow: "auto" }}>
          {activeTab === "home" && (
            <>
              {sevaList && trustData?.isSevaEnabled ? (
                <ServiceList
                  setSevaList={setSevaList}
                  setBookingSeva={setBookingSeva}
                  setSelectedSeva={setSelectedSeva}
                />
              ) : bookingSeva && trustData?.isSevaEnabled ? (
                <SevaBooking
                  setSevaList={setSevaList}
                  setBookingSeva={setBookingSeva}
                  selectedSeva={selectedSeva}
                />
              ) : donationList && trustData?.donationViaPortfolioApp ? (
                <AddDonation />
              ) : chaukaList && trustData?.hasDharmshala ? (
                <AddAccommodation bookingCategory="chauka" isChaturmas={isChaturmasSource} />
              ) : accommodationList && trustData?.hasDharmshala ? (
                <AddAccommodation bookingCategory="accommodation" isChaturmas={isChaturmasSource} />
              ) : applicationList && trustData?.isApplicationEnabled ? (
                <ApplicationList />
              ) : chaturmasBookingList ? (
                <Row gutter={[{ xs: 16, sm: 16, md: 24, lg: 32 }, 16]}>
                  {[
                    {
                      _id: "aawas",
                      title: "Accommodation/Aawas Booking",
                      buttonName: "Book",
                      image: dharmshalaIcon,
                      key: "accommodation",
                    },
                  ].map((item) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={item._id} className="cardColumn">
                      <Card className="cardContainer" hoverable style={{ width: "100%", marginLeft: "0px" }}>
                        <div className="cardTitle1">{item.title}</div>
                        <div className="d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                            <img className="cardImage1" alt={item.title} src={item.image} style={{ maxWidth: "150px", maxHeight: "150px", objectFit: "contain" }} />
                          </div>
                          <Button
                            color="primary"
                            onClick={() => {
                              if (!user) {
                                navigate("/login", { state: { from: `/home?page=${item.key}&source=chaturmas` } });
                              } else {
                                navigate(`/home?page=${item.key}&source=chaturmas`);
                              }
                            }}
                          >
                            {item.buttonName}
                          </Button>
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              ) : (
                <Row gutter={[{ xs: 16, sm: 16, md: 24, lg: 32 }, 16]}>
                  {homeData.filter((item) => item.isEnable).map((item) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={item._id} className="cardColumn">
                      <Card className="cardContainer" hoverable style={{ width: "100%", marginLeft: "0px" }}>
                        <div className="cardTitle1">{item.title}</div>
                        <div className="d-flex flex-column justify-content-between">
                          <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                            <img className="cardImage1" alt={item.title} src={item.image} style={{ maxWidth: "150px", maxHeight: "150px", objectFit: "contain" }} />
                          </div>
                          <Button color="primary" onClick={() => handleButtonClick(item.key, item._id)}>
                            {item.buttonName}
                          </Button>
                        </div>
                      </Card>
                    </Col> 
                  ))}
                </Row>
              )}
            </>
          )}

          {activeTab === "bookingHistory" && (
            <div>
              <BookingHistory />
            </div>
          )}
          {(activeTab === "bookingTable" || activeTab === "bookingTable_aawas" || activeTab === "bookingTable_chauka") && (
            <div>
              <BookingTable isChaturmas={isChaturmasMode} category={activeTab === "bookingTable_chauka" ? "chauka" : "aawas"} />
            </div>
          )}
          {activeTab === "account" && (
            <div>
              <UserProfile />
            </div>
          )}
          {activeTab === "donationReciepts" && (
            <div>
              <DonationReceiptsTable />
            </div>
          )}
          {activeTab === "myApplications" && (
            <div>
              <MyApplications />
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
}

export default SevaList;
